import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col my-3 gap-3 mb-24 max-w-[40rem] mx-auto" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "font-bold bg-light-gray-100 py-3 pl-3 rounded-base" }
const _hoisted_4 = { class: "flex flex-col gap-3" }
const _hoisted_5 = { class: "font-bold bg-light-gray-100 py-3 pl-3 rounded-base" }
const _hoisted_6 = { class: "flex flex-col gap-3" }
const _hoisted_7 = { class: "font-bold bg-light-gray-100 py-3 pl-3 rounded-base" }
const _hoisted_8 = { class: "font-semibold text-lg" }
const _hoisted_9 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "flex min-w-50 p-2"
}
const _hoisted_11 = { class: "flex flex-col pl-2" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Current/last company", -1)
const _hoisted_14 = {
  key: 1,
  class: "flex min-w-50 p-2"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "flex flex-col pl-2" }
const _hoisted_17 = { class: "font-semibold capitalize" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Field of practice", -1)
const _hoisted_19 = {
  key: 2,
  class: "flex min-w-50 p-2"
}
const _hoisted_20 = { class: "flex flex-col pl-2" }
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Work experience", -1)
const _hoisted_23 = {
  key: 3,
  class: "flex min-w-50 p-2"
}
const _hoisted_24 = { class: "flex flex-col pl-2" }
const _hoisted_25 = { class: "font-semibold capitalize" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Open to", -1)
const _hoisted_27 = {
  key: 4,
  class: "flex min-w-50 p-2"
}
const _hoisted_28 = { class: "flex flex-col pl-2" }
const _hoisted_29 = { class: "font-semibold capitalize" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "Current status", -1)
const _hoisted_31 = {
  key: 1,
  id: "connections",
  class: "flex flex-row flex-wrap p-10 w-full justify-between bg-primary-violet rounded-[20px]"
}
const _hoisted_32 = { class: "font-black text-2xl text-white my-auto" }
const _hoisted_33 = { class: "flex flex-wrap gap-5" }
const _hoisted_34 = ["href"]
const _hoisted_35 = ["src", "alt"]

import { computed, onMounted } from "vue"
  import { useUserStore } from "@/store/user"
  import { useResourcesStore } from "@/store/resources"
  import { DevicePhoneMobileIcon, EnvelopeIcon, MapPinIcon, UserIcon, CalendarIcon } from "@heroicons/vue/24/outline"
  import { BuildingOfficeIcon, BriefcaseIcon, MagnifyingGlassIcon, HeartIcon } from "@heroicons/vue/24/solid"
  import { includes, filter } from "lodash"
  import { format } from "date-fns"

  // component
  // import CardTemplate from "@/components/template/card.vue"

  // images
  import FacebookIcon from "@/assets/images/social-media/facebook-icon.svg"
  import DribbleIcon from "@/assets/images/social-media/dribble-icon.svg"
  import InstagramIcon from "@/assets/images/social-media/instagram-icon.svg"
  import YoutubeIcon from "@/assets/images/social-media/youtube-icon.svg"
  import BehanceIcon from "@/assets/images/social-media/behance-icon.svg"
  import TiktokIcon from "@/assets/images/social-media/tiktok-icon.svg"
  import LinkedinIcon from "@/assets/images/social-media/linkedin-icon.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutContainer',
  setup(__props) {

  const userStore = useUserStore()
  const resourcesStore = useResourcesStore()

  const profile = computed(() => userStore.userTalentProfile)
  const industries = computed(() => resourcesStore.industries)
  const platforms = [
    {
      icon: FacebookIcon,
      name: "Facebook",
      value: "Facebook",
    },
    {
      icon: InstagramIcon,
      name: "Instagram",
      value: "Instagram",
    },
    {
      icon: YoutubeIcon,
      name: "YouTube",
      value: "YouTube",
    },
    {
      icon: TiktokIcon,
      name: "TikTok",
      value: "TikTok",
    },
    {
      icon: LinkedinIcon,
      name: "LinkedIn",
      value: "LinkedIn",
    },
    {
      icon: BehanceIcon,
      name: "Behance",
      value: "Behance",
    },
    {
      icon: DribbleIcon,
      name: "Dribble",
      value: "Dribble",
    },
  ]

  /**
   * replace &nbsp; with whitespace
   */
  const replacenbsp = (val: string) => val.replaceAll("&nbsp;", " ")

  /**
   *
   * @param platform - type of platform
   *
   * returns platform icon (string)
   */
  const platformIcon = (platform: string) => {
    const getIcon = platforms.filter((val: any) => val.value === platform)
    return getIcon.length ? getIcon[0].icon : ""
  }

  /**
   * is data visible
   */
  const isVisible = (column: string) => {
    return includes(userStore.userTalentProfile.visibility, column)
  }

  /**
   * format date
   */
  const formatDate = (dateString: string) => format(new Date(dateString), "MMMM dd, yyyy")

  const getIndustry = (id: any) => {
    const industry = filter(industries.value, (val) => `${val.id}` === `${id}`)
    return industry.length ? industry[0] : { name: "", badge: "" }
  }

  onMounted(async () => {
    await resourcesStore.retrieveIndustries()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_card, { class: "flex flex-col mx-3 gap-2 p-5" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode("First name "),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(profile).name.first_name), 1)
        ]),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode("Last name "),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(profile).name.last_name), 1)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode("Field of practice "),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(profile).employment.role), 1)
        ])
      ]),
      _: 1
    }),
    (isVisible('company') || isVisible('company_location') || isVisible('industry') || isVisible('years_exp') || isVisible('work_setup') || isVisible('status'))
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 0,
          id: "work-info",
          class: "flex flex-col w-full gap-4 p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(profile).name.first_name.endsWith("s") ? `${_unref(profile).name.first_name}'` : `${_unref(profile).name.first_name}'s`) + " Work Info", 1),
            _createElementVNode("div", _hoisted_9, [
              (isVisible('company') || isVisible('company_location'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_unref(BuildingOfficeIcon), { class: "h-6 text-primary-violet m-auto" }),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(isVisible("company") ? _unref(profile).employment.company || "" : "") + _toDisplayString(isVisible("company") && isVisible("company_location") && (_unref(profile).employment.company_location.city || _unref(profile).employment.company_location.country) ? ", " : "") + " " + _toDisplayString(isVisible("company_location")
                  ? `${_unref(profile).employment.company_location.city}${_unref(profile).employment.company_location.city && _unref(profile).employment.company_location.country ? ", " : ""}${
                      _unref(profile).employment.company_location.country
                    }`
                  : ""), 1),
                      _hoisted_13
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isVisible('industry'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("img", {
                      class: "h-6 text-primary-violet m-auto rounded",
                      src: `https://s3.amazonaws.com/assets.workbean.co/badge/industry/${getIndustry(_unref(profile).employment.industry.id).badge}.svg`,
                      alt: ""
                    }, null, 8, _hoisted_15),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(getIndustry(_unref(profile).employment.industry.id).name), 1),
                      _hoisted_18
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isVisible('years_exp'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(BriefcaseIcon), { class: "h-6 text-primary-violet m-auto" }),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(profile).employment.years_exp) + " " + _toDisplayString(_unref(profile).employment.years_exp ? (_unref(profile).employment.years_exp > 1 ? "years" : "year") : ""), 1),
                      _hoisted_22
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isVisible('work_setup'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_unref(MagnifyingGlassIcon), { class: "h-6 text-primary-violet m-auto" }),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(profile).employment.work_setup.join(", ")), 1),
                      _hoisted_26
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isVisible('status'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_unref(HeartIcon), { class: "h-6 text-primary-violet m-auto" }),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(profile).employment.status), 1),
                      _hoisted_30
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(profile).socials.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("p", _hoisted_32, "Connect with " + _toDisplayString(_unref(profile).name.first_name), 1),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profile).socials, (social, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: `${index}_id`,
                href: social.link,
                target: '_blank',
                class: "h-8 w-auto"
              }, [
                _createElementVNode("img", {
                  src: platformIcon(social.media_type),
                  alt: social.media_type,
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_35)
              ], 8, _hoisted_34))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})